import React, { useState } from 'react';
import MarketingLayout from '../components/MarketingLayout';
import { Link } from 'react-router-dom';
import '../marketing.css';

const CompaniesFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "1. What is PlayBack Token?",
      answer: "PlayBack Token is a platform that verifies and values volunteer hours from sports clubs, community organizations, and charities. It allows companies to support verified community impact for ESG and CSR reporting, ensuring full transparency and credibility."
    },
    {
      question: "2. How does the purchase process work?",
      answer: "Companies can browse available bundles of verified volunteer hours in the PlayBack Token marketplace. Each bundle includes details on participating clubs, the type of activities involved, and the areas where the work took place. Once a purchase is made, the company immediately receives a verified record and report."
    },
    {
      question: "3. What do companies receive after purchasing?",
      answer: "After purchasing, companies receive an ESG compliance report (PDF). It includes financial details, a list of supported clubs and activities, and a breakdown of the geographic impact. Each report provides clear and verifiable documentation for internal or external ESG reporting."
    },
    {
      question: "4. How is authenticity guaranteed?",
      answer: "All volunteer hours are verified through a two-step approval process — first by the club and then by the platform. This ensures every hour purchased represents genuine, approved community work. Once verified, the record becomes permanent and cannot be altered."
    },
    {
      question: "5. How are funds distributed?",
      answer: "PlayBack Token automatically allocates 90% of each transaction to the clubs whose volunteer hours were included in the purchase. The remaining 10% supports platform operations. All payments are fully traceable and viewable in the system dashboard."
    },
    {
      question: "6. Is PlayBack Token GDPR and data protection compliant?",
      answer: "Yes. The system is fully compliant with GDPR and other data protection standards. Personal data such as volunteer names are never shared with companies. Only anonymous volunteer IDs and general activity details appear in reports."
    },
    {
      question: "7. How can companies use PlayBack Token purchases for ESG reporting?",
      answer: "Each ESG report provides clear, verifiable evidence of social impact spending — including the number of hours supported, the types of community work funded, and the locations impacted. This documentation can be used in annual ESG reports, CSR communications, and external audits."
    },
    {
      question: "8. What makes PlayBack Token different from traditional donations?",
      answer: "Unlike a general sponsorship or grant, every PlayBack Token purchase provides transparent proof of impact. Companies can see exactly where their support goes, how much reached each club, and the real community activities their contribution made possible — creating measurable social value."
    }
  ];

  return (
    <MarketingLayout>
      {/* Hero Section */}
      <section className="faq-hero">
        <div className="container">
          <h1>Companies FAQ</h1>
          <p>Your guide to transparent, verified community impact through PlayBack Token</p>
        </div>
      </section>

      {/* FAQ Content */}
      <div className="faq-container">
        <Link to="/companies" className="back-link">← Back to Companies Page</Link>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span className="faq-question-text">{faq.question}</span>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${openIndex === index ? 'active' : ''}`}>
                <div className="faq-answer-content">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MarketingLayout>
  );
};

export default CompaniesFAQ;
